// // Footer.jsx
// import { motion } from "framer-motion";
// import { FaFacebookF, FaLinkedinIn, FaWhatsapp, FaEnvelope } from "react-icons/fa";

// export const Footer = () => (
//   <motion.footer
//     initial={{ opacity: 0, y: 50 }}
//     whileInView={{ opacity: 1, y: 0 }}
//     transition={{ duration: 0.8 }}
//     viewport={{ once: false }}
//     className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-16 px-6"
//   >
//     <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 md:grid-cols-3 gap-10 text-left">
//       {/* Logo + Description */}
//       <div>
//         <h2 className="text-2xl md:text-2xl font-extrabold text-blue-400 tracking-wide">MominHussain</h2>
//         <p className="mt-4 text-sm text-gray-300 leading-relaxed">
//         Freelance web developer based in Pakistan, building clean, fast, and mobile-ready websites for businesses and individuals.
//         </p>
//         <div className="mt-6 flex gap-3">
//           <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-blue-600 p-2 rounded-full hover:scale-110 transition">
//             <FaFacebookF />
//           </a>
//           <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="bg-blue-500 p-2 rounded-full hover:scale-110 transition">
//             <FaLinkedinIn />
//           </a>
//           <a
//             href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="bg-green-600 p-2 rounded-full hover:scale-110 transition"
//           >
//             <FaWhatsapp />
//           </a>

//           <a href="mailto:mominhussain446@gmail.com" target="_blank" rel="noopener noreferrer" className="bg-red-500 p-2 rounded-full hover:scale-110 transition">
//             <FaEnvelope />
//           </a>
//         </div>
//       </div>

//       {/* Quick Links */}
//       <div>
//         <h3 className="text-lg font-semibold mb-4 text-blue-300">Quick Links</h3>
//         <ul className="space-y-2 text-sm text-gray-300">
//           {["Home", "About Me", "Services", "Portfolio", "Pricing", "Contact"].map((item) => (
//             <li key={item}>
//               <a href={`#${item.toLowerCase().replace(" ", "")}`} className="hover:text-white transition">
//                 {item}
//               </a>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Services */}
//       <div>
//         <h3 className="text-lg font-semibold mb-4 text-blue-300">Services</h3>
//         <ul className="space-y-2 text-sm text-gray-300">
//           <li>Website Design</li>
//           <li>E-Commerce Sites</li>
//           <li>Portfolio Sites</li>
//           <li>Speed Optimization</li>
//           <li>Domain & Hosting Setup</li>
//         </ul>
//       </div>

//       {/* Contact Info */}
//       <div>
//         <h3 className="text-lg font-semibold mb-4 text-blue-300">Contact</h3>
//         <p className="text-sm text-gray-300 leading-relaxed">
//           WhatsApp:{" "}
//           <a href="https://wa.me/923112891862?text=Hi%20Momin%2C%20I%20want%20to%20discuss%20a%20project" className="text-blue-400 hover:text-white transition">
//             +92 311 2891862
//           </a>
//           <br />
//           Email:{" "}
//           <a href="mailto:mominhussain446@gmail.com" className="text-blue-400 hover:text-white transition">
//             mominhussain446@gmail.com
//           </a>
//           <br />
//           Karachi, Pakistan
//         </p>
//       </div>
//     </div>

//     <div className="text-center mt-12 text-sm text-gray-500 border-t border-gray-700 pt-6">
//       &copy; {new Date().getFullYear()} MominHussain. All rights reserved.
//     </div>
//   </motion.footer>
// );


// Footer.jsx
import { motion, useInView } from "framer-motion";
import { 
  FaFacebookF, FaLinkedinIn, FaWhatsapp, FaEnvelope, 
  FaTwitter, FaGithub, FaInstagram, FaArrowUp,
  FaHeart, FaLaptopCode, FaRocket, FaShieldAlt,
  FaClock, FaMapMarkerAlt, FaPhoneAlt
} from "react-icons/fa";
import { useState, useEffect, useRef } from "react";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const footerRef = useRef(null);
  const isInView = useInView(footerRef, { once: false, margin: "-100px" });

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 3000);
      // Here you can add your newsletter subscription API call
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const socialLinks = [
    { icon: FaFacebookF, href: "https://www.facebook.com/profile.php?id=61587516396282", color: "bg-blue-600", hoverColor: "hover:bg-blue-500" },
    { icon: FaLinkedinIn, href: "https://www.linkedin.com/in/momin-hussain-5133062b8/", color: "bg-blue-700", hoverColor: "hover:bg-blue-600" },
    // { icon: FaWhatsapp, href: "https://wa.me/923112891862", color: "bg-green-600", hoverColor: "hover:bg-green-500" },
    { icon: FaTwitter, href: "https://x.com/MominHu4782029", color: "bg-sky-500", hoverColor: "hover:bg-sky-400" },
    // { icon: FaGithub, href: "https://github.com/MominHussain123", color: "bg-gray-700", hoverColor: "hover:bg-gray-600" },
    { icon: FaInstagram, href: "https://www.instagram.com/hzmominhussain/", color: "bg-pink-600", hoverColor: "hover:bg-pink-500" },
  ];

  const quickLinks = [
    { name: "Home", hash: "#home", icon: FaRocket },
    { name: "About Me", hash: "#about", icon: FaLaptopCode },
    { name: "Services", hash: "#services", icon: FaShieldAlt },
    { name: "Portfolio", hash: "#portfolio", icon: FaLaptopCode },
    // { name: "Pricing", hash: "#pricing", icon: FaRocket },
    { name: "Contact", hash: "#contact", icon: FaEnvelope },
  ];

  const services = [
    "Website Design & Development",
    "E-Commerce Solutions",
    "Custom Web Applications",
    "Speed & Performance Optimization",
    "Domain & Hosting Setup",
    "SEO & Digital Marketing",
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        duration: 0.6,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.footer
      ref={footerRef}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={containerVariants}
      className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white overflow-hidden"
    >
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <motion.div
          className="absolute top-0 left-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"
          animate={{
            x: [0, 100, 0],
            y: [0, 50, 0],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <motion.div
          className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl"
          animate={{
            x: [0, -100, 0],
            y: [0, -50, 0],
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-1 h-1 bg-white/20 rounded-full"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -30, 0],
              opacity: [0, 0.5, 0],
            }}
            transition={{
              duration: Math.random() * 5 + 3,
              repeat: Infinity,
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>

      {/* Main Footer Content */}
      <div className="relative max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo + Description */}
          <motion.div variants={itemVariants}>
            <motion.h2 
              className="text-3xl font-black bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text text-transparent"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              Momin<span className="text-white">Hussain</span>
            </motion.h2>
            <p className="mt-4 text-sm text-gray-300 leading-relaxed">
              Freelance web developer based in Pakistan, building clean, fast, 
              and mobile-ready websites for businesses and individuals worldwide.
            </p>
            
            {/* Social Links */}
            <div className="mt-6 flex flex-wrap gap-3">
              {socialLinks.map((social, idx) => (
                <motion.a
                  key={idx}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${social.color} ${social.hoverColor} p-2.5 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl`}
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  whileTap={{ scale: 0.95 }}
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: idx * 0.05 }}
                >
                  <social.icon className="w-4 h-4" />
                </motion.a>
              ))}
            </div>

            {/* Trust Badge */}
            <motion.div 
              className="mt-6 flex items-center gap-2 text-xs text-gray-400"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <FaHeart className="text-red-500 animate-pulse" />
              <span>100% Client Satisfaction</span>
              <span className="w-1 h-1 bg-gray-600 rounded-full" />
              <FaShieldAlt className="text-blue-500" />
              <span>Secure & Reliable</span>
            </motion.div>
          </motion.div>

          {/* Quick Links */}
          <motion.div variants={itemVariants}>
            <h3 className="text-lg font-bold mb-6 text-transparent bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, idx) => (
                <motion.li
                  key={link.name}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: idx * 0.05 }}
                >
                  <a
                    href={link.hash}
                    className="flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-all duration-300 group"
                  >
                    <link.icon className="w-3 h-3 text-blue-400 group-hover:scale-125 transition-transform" />
                    <span className="group-hover:translate-x-1 transition-transform">
                      {link.name}
                    </span>
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div variants={itemVariants}>
            <h3 className="text-lg font-bold mb-6 text-transparent bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text">
              Services
            </h3>
            <ul className="space-y-3">
              {services.map((service, idx) => (
                <motion.li
                  key={service}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: idx * 0.05 }}
                  className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center gap-2 group"
                >
                  <span className="w-1 h-1 bg-emerald-500 rounded-full group-hover:scale-150 transition-transform" />
                  {service}
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Contact & Newsletter */}
          <motion.div variants={itemVariants}>
            <h3 className="text-lg font-bold mb-6 text-transparent bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text">
              Get In Touch
            </h3>
            
            {/* Contact Info */}
            <div className="space-y-3 mb-6">
              <motion.a
                href="https://wa.me/923112891862"
                className="flex items-center gap-3 text-sm text-gray-300 hover:text-white transition-colors group"
                whileHover={{ x: 5 }}
              >
                <div className="p-1.5 bg-green-600/20 rounded-lg group-hover:bg-green-600 transition-colors">
                  <FaWhatsapp className="w-3 h-3 text-green-500" />
                </div>
                <span>+92 311 2891862</span>
              </motion.a>
              
              <motion.a
                href="mailto:mominhussain446@gmail.com"
                className="flex items-center gap-3 text-sm text-gray-300 hover:text-white transition-colors group"
                whileHover={{ x: 5 }}
              >
                <div className="p-1.5 bg-red-600/20 rounded-lg group-hover:bg-red-600 transition-colors">
                  <FaEnvelope className="w-3 h-3 text-red-500" />
                </div>
                <span>mominhussain446@gmail.com</span>
              </motion.a>
              
              <motion.div
                className="flex items-center gap-3 text-sm text-gray-300"
                whileHover={{ x: 5 }}
              >
                <div className="p-1.5 bg-blue-600/20 rounded-lg">
                  <FaMapMarkerAlt className="w-3 h-3 text-blue-500" />
                </div>
                <span>Karachi, Pakistan</span>
              </motion.div>
              
              {/* <motion.div
                className="flex items-center gap-3 text-sm text-gray-300"
                whileHover={{ x: 5 }}
              >
                <div className="p-1.5 bg-emerald-600/20 rounded-lg">
                  <FaClock className="w-3 h-3 text-emerald-500" />
                </div>
                <span>Mon - Fri, 9AM - 6PM</span>
              </motion.div> */}
            </div>

            {/* Newsletter Subscription */}
            <div className="mt-6">
              <p className="text-sm text-gray-300 mb-3">Subscribe to my newsletter</p>
              <form onSubmit={handleSubscribe} className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full px-4 py-2.5 bg-gray-800/50 border border-gray-700 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  required
                />
                <motion.button
                  type="submit"
                  className="absolute right-1 top-1 px-3 py-1.5 bg-gradient-to-r from-blue-600 to-emerald-500 rounded-md text-white text-xs font-medium"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Subscribe
                </motion.button>
              </form>
              {subscribed && (
                <motion.p
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0 }}
                  className="text-xs text-green-500 mt-2"
                >
                  ✓ Subscribed successfully!
                </motion.p>
              )}
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          variants={itemVariants}
          className="mt-12 pt-8 border-t border-gray-800"
        >
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-500">
              &copy; {currentYear} MominHussain. Crafted with{" "}
              <FaHeart className="inline text-red-500 animate-pulse" /> in Pakistan
            </div>
            
            <div className="flex gap-6 text-xs text-gray-500">
              <a href="#" className="hover:text-white transition">Privacy Policy</a>
              <a href="#" className="hover:text-white transition">Terms of Service</a>
              <a href="#" className="hover:text-white transition">Sitemap</a>
            </div>
            
            <div className="flex gap-2">
              <motion.button
                onClick={scrollToTop}
                className="p-2 bg-gray-800 rounded-full hover:bg-gray-700 transition-all"
                whileHover={{ scale: 1.1, y: -3 }}
                whileTap={{ scale: 0.9 }}
                animate={{ y: [0, -3, 0] }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                <FaArrowUp className="w-3 h-3 text-blue-400" />
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Decorative Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-blue-500 to-emerald-500" />
    </motion.footer>
  );
};